const areas = [   
  {
    id: "magyarorszag",
    name: "Magyarország",
    region: "magyarorszag",
    male_population: 4663794,
  },
  {
    id: "kozep_magyarorszag",
    name: "Közép-Magyarország",
    region: "kozep_magyarorszag",
    male_population: 1440428,
  },
  {
    id: "budapest",
    name: "Budapest",
    region: "kozep_magyarorszag",
    male_population: 806780,
  },
  {
    id: "pest",
    name: "Pest megye (Budapest nélkül)",
    region: "kozep_magyarorszag",
    male_population: 633648,
  },
  {
    id: "kozep_dunantul",
    name: "Közép-Dunántúl",
    region: "kozep_dunantul",
    male_population: 512537,
  },
  {
    id: "fejer",
    name: "Fejér megye",
    region: "kozep_dunantul",
    male_population: 202948,
  },
  {
    id: "komarom_esztergom",
    name: "Komárom-Esztergom megye",
    region: "kozep_dunantul",
    male_population: 144675,
  },
  {
    id: "veszprem",
    name: "Veszprém megye",
    region: "kozep_dunantul",
    male_population: 164914,
  },	
  {
    id: "nyugat_dunantul",
    name: "Nyugat-Dunántúl",
    region: "nyugat_dunantul",
    male_population: 482314,
  },
  {
    id: "gyor_moson_sopron",
    name: "Győr-Moson-Sopron megye",
    region: "nyugat_dunantul",
    male_population: 233350,
  },
  {
    id: "vas",
    name: "Vas megye",
    region: "nyugat_dunantul",
    male_population: 122166,
  },
  {
    id: "zala",
    name: "Zala megye",
    region: "nyugat_dunantul",
    male_population: 126798,
  },
  {
    id: "del_dunantul",
    name: "Dél-Dunántúl",
    region: "del_dunantul",
    male_population: 415426,
  },
  {
    id: "baranya",
    name: "Baranya megye",
    region: "del_dunantul",
    male_population: 169196,
  },
  {
    id: "somogy",
    name: "Somogy megye",
    region: "del_dunantul",
    male_population: 143575,
  },
  {
    id: "tolna",
    name: "Tolna megye",
    region: "del_dunantul",
    male_population: 102655,
  },
  {
    id: "eszak_magyarorszag",
    name: "Észak-Magyarország",
    region: "eszak_magyarorszag",
    male_population: 532716,
  },
  {
    id: "borsod_abauj_zemplen",
    name: "Borsod-Abaúj-Zemplén megye",
    region: "eszak_magyarorszag",
    male_population: 303271,
  },
  {
    id: "heves",
    name: "Heves megye",
    region: "eszak_magyarorszag",
    male_population: 138959,
  },
  {
    id: "nograd",
    name: "Nógrád megye",
    region: "eszak_magyarorszag",
    male_population: 90486,
  },
  {
    id: "eszak_alfold",
    name: "Észak-Alföld",
    region: "eszak_alfold",
    male_population: 695253,
  },
  {
    id: "hajdu_bihar",
    name: "Hajdú-Bihar megye",
    region: "eszak_alfold",
    male_population: 253940,
  },
  {
    id: "jasz_nagykun_szolnok",
    name: "Jász-Nagykun-Szolnok megye",
    region: "eszak_alfold",
    male_population: 175711,
  },
  {
    id: "szabolcs_szatmar_bereg",
    name: "Szabolcs-Szatmár-Bereg megye",
    region: "eszak_alfold",
    male_population: 265602,
  },
  {
    id: "del_alfold",
    name: "Észak-Alföld",
    region: "del_alfold",
    male_population: 585120,
  },
  {
    id: "bacs_kiskun",
    name: "Bács-Kiskun megye",
    region: "del_alfold",
    male_population: 240362,
  },
  {
    id: "bekes",
    name: "Békés megye",
    region: "del_alfold",
    male_population: 156464,
  },
  {
    id: "csongrad_csanad",
    name: "Csongrád-Csanád megye",
    region: "del_alfold",
    male_population: 188294,
  }  
];

export default areas;
